import { CopyIcon, DownloadIcon, EditIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  Heading,
  IconButton,
  Link,
  ListItem,
  Spacer,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { Link as RouteLink } from "react-router-dom";

import { successToast } from "../../shared/helper/ToastHelper";
import { Paths } from "../../shared/model/Constants";
import { TestDto } from "../../shared/model/Dto";
import DeleteTestIcon from "./DeleteTestIcon";

type TestItemProps = {
  test: TestDto;
  onTestDeleted: (id: string) => void;
  onTestDownloaded: (id: string, testName: string) => void;
};

const TestItem = (props: TestItemProps) => {
  const toast = useToast();

  function handleDeleteClick(id: string) {
    props.onTestDeleted(id);
  }

  function generateLink(test: TestDto) {
    // return `${process.env.REACT_APP_FRONTEND_URL}${Paths.TESTS_PUBLIC_ID}`.replace(
    return `${window.location.origin}${Paths.TESTS_PUBLIC_ID}`.replace(
      ":publicId",
      test.publicId
    );
  }

  function goToTest(test: TestDto) {
    window.open(generateLink(test), "_blank");
    successToast(toast, "Enlace abierto en una nueva pestaña");
  }

  function copyToClipboard(test: TestDto) {
    navigator.clipboard.writeText(generateLink(test));
    successToast(toast, "Enlace copiado");
  }

  function downloadTest(id: string, testName: string) {
    props.onTestDownloaded(id, testName);
  }

  return (
    <ListItem>
      <Flex
        marginTop="2"
        marginBottom="2"
        padding="2"
        borderWidth="1px"
        borderRadius="lg"
        borderColor="gray.300"
        borderStyle="solid"
        align="center"
      >
        <Box>
          <Heading as="h3" size="md">
            <Link
              as={RouteLink}
              to={Paths.ADMIN_TESTS_ID.replace(":id", props.test.id.toString())}
            >
              {props.test.name + " - " + props.test.publicId}
            </Link>
          </Heading>
        </Box>
        <Spacer />
        <Box>
          <IconButton
            variant="outline"
            colorScheme="gray"
            aria-label="Descargar en formato Yaml"
            size="md"
            icon={<DownloadIcon />}
            marginRight="2"
            onClick={() => downloadTest(props.test.id, props.test.name)}
          />
          <IconButton
            variant="outline"
            colorScheme="gray"
            aria-label="Abrir enlace de prueba"
            size="md"
            icon={<ExternalLinkIcon />}
            marginRight="2"
            onClick={() => goToTest(props.test)}
          />
          <IconButton
            variant="outline"
            colorScheme="gray"
            aria-label="Copiar enlace de prueba"
            size="md"
            icon={<CopyIcon />}
            marginRight="2"
            onClick={() => copyToClipboard(props.test)}
          />
          <IconButton
            variant="outline"
            colorScheme="gray"
            aria-label="Editar prueba"
            size="md"
            icon={<EditIcon />}
            marginRight="2"
          />
          <DeleteTestIcon
            onTestDeleted={() => handleDeleteClick(props.test.id)}
          />
        </Box>
      </Flex>
    </ListItem>
  );
};

export default TestItem;
